import { render, staticRenderFns } from "./activeRepe.vue?vue&type=template&id=44f10fb7&scoped=true&"
import script from "./activeRepe.vue?vue&type=script&lang=js&"
export * from "./activeRepe.vue?vue&type=script&lang=js&"
import style0 from "./activeRepe.vue?vue&type=style&index=0&id=44f10fb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f10fb7",
  null
  
)

export default component.exports